module.exports = __webpack_public_path__ + "img/DocReRouteDemo3.99d526aa.gif";